module.exports = "//static.hsappstatic.net/LoginUI/static-1.15098/img/login-marketing-image.png"